export default "__VITE_ASSET__7af6d34b__"